import React, { useState, useRef } from "react";
import styles from "./WorkUpload.module.css";

export default function WorkUpload({ onBack }) {
  const [images, setImages] = useState([]);
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("Carpentry");
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const fileInputRef = useRef(null);

  // =========================================================
  // HANDLE IMAGE SELECTION / DRAG & DROP
  // =========================================================

  const handleImageChange = (e) => {
    const selectedFiles = Array.from(
      e.target.files || e.dataTransfer?.files || []
    );

    if (selectedFiles.length === 0) return;

    if (selectedFiles.length + images.length > 5) {
      alert("Aap max 5 images hi upload kar sakte hain.");
      return;
    }

    const validFiles = selectedFiles.filter((file) => {
      if (!file.type.startsWith("image/")) {
        return false;
      }

      if (file.size > 5 * 1024 * 1024) {
        alert(`${file.name} 5MB se zyada hai.`);
        return false;
      }

      return true;
    });

    const newImages = validFiles.map((file) => ({
      id: Math.random().toString(36).substring(2, 9),
      file,
      url: URL.createObjectURL(file),
    }));

    setImages((prev) => [...prev, ...newImages]);

    // Allow same file to be selected again
    if (e.target) {
      e.target.value = "";
    }
  };

  // =========================================================
  // REMOVE IMAGE
  // =========================================================

  const handleRemoveImage = (id) => {
    setImages((prev) => {
      const imageToRemove = prev.find(
        (img) => img.id === id
      );

      if (imageToRemove?.url) {
        URL.revokeObjectURL(imageToRemove.url);
      }

      return prev.filter((img) => img.id !== id);
    });
  };

  // =========================================================
  // SUBMIT FORM
  // =========================================================

  const handleSubmit = (e) => {
    e.preventDefault();

    if (images.length === 0) {
      alert(
        "Kripya kam se kam ek image zaroor select karein."
      );
      return;
    }

    if (!title.trim()) {
      alert("Kripya Work Title enter karein.");
      return;
    }

    setIsSubmitting(true);
    setSuccessMsg("");

    // Simulated API upload
    setTimeout(() => {
      setIsSubmitting(false);

      setSuccessMsg(
        "Aapka kaam safaltapurvak upload ho gaya hai!"
      );

      // Reset form
      setTitle("");
      setDescription("");

      images.forEach((img) => {
        if (img.url) {
          URL.revokeObjectURL(img.url);
        }
      });

      setImages([]);
      setCategory("Carpentry");
    }, 1500);
  };

  return (
    <div className={styles.screenWrapper}>

      {/* Background decorative glow */}
      <div className={styles.backgroundGlowOne}></div>
      <div className={styles.backgroundGlowTwo}></div>

      <div className={styles.deviceFrame}>

        {/* =====================================================
            HEADER
        ====================================================== */}

        <header className={styles.appBar}>

          {/* Back Button */}
          <button
            type="button"
            className={styles.backBtn}
            onClick={onBack}
            aria-label="Go Back"
            title="Go Back"
          >
            <svg
              width="20"
              height="16"
              viewBox="0 0 24 16"
              fill="none"
              stroke="#005CA9"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M19 8H5" />
              <polyline points="12 1 5 8 12 15" />
            </svg>
          </button>

          {/* Brand */}
          <div className={styles.brandContainer}>
            <span className={styles.brandBro}>
              Bro
            </span>

            <span className={styles.brandBizee}>
              Bizee
            </span>
          </div>

          {/* Header Title */}
          <span className={styles.headerTitle}>
            Upload Work
          </span>

        </header>

        {/* =====================================================
            SCROLLABLE FORM
        ====================================================== */}

        <div className={styles.scrollContainer}>

          <div className={styles.pageIntro}>

            <div className={styles.pageIcon}>
              <svg
                width="25"
                height="25"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect
                  x="3"
                  y="3"
                  width="18"
                  height="18"
                  rx="3"
                />
                <circle
                  cx="8.5"
                  cy="8.5"
                  r="1.5"
                />
                <polyline points="21 15 16 10 5 21" />
              </svg>
            </div>

            <div>
              <div className={styles.pageHeading}>
                Share Your Latest Work
              </div>

              <p className={styles.subHeading}>
                Apne achhe kaam ki photos dikha kar
                zyada orders paayein.
              </p>
            </div>

          </div>

          <form
            onSubmit={handleSubmit}
            className={styles.uploadForm}
          >

            {/* =================================================
                CATEGORY
            ================================================== */}

            <div className={styles.fieldGroup}>

              <label className={styles.label}>
                Select Category / Service
              </label>

              <div className={styles.inputShell}>

                <span className={styles.inputIcon}>
                  ✦
                </span>

                <select
                  value={category}
                  onChange={(e) =>
                    setCategory(e.target.value)
                  }
                  className={styles.selectInput}
                >
                  <option value="Carpentry">
                    Carpenter (Khaati Work)
                  </option>

                  <option value="Plumbing">
                    Plumber (Nal Fitting)
                  </option>

                  <option value="Electrical">
                    Electrician (Bijli Work)
                  </option>

                  <option value="Painting">
                    Painter (Color & Paint)
                  </option>

                  <option value="Cleaning">
                    Cleaning & Housekeeping
                  </option>
                </select>

              </div>

            </div>

            {/* =================================================
                WORK TITLE
            ================================================== */}

            <div className={styles.fieldGroup}>

              <label className={styles.label}>
                Work Title
              </label>

              <input
                type="text"
                placeholder="e.g., Modular Kitchen Cabinet Assembly"
                value={title}
                onChange={(e) =>
                  setTitle(e.target.value)
                }
                className={styles.textInput}
                required
              />

            </div>

            {/* =================================================
                IMAGE UPLOAD
            ================================================== */}

            <div className={styles.fieldGroup}>

              <div className={styles.labelRow}>

                <label className={styles.label}>
                  Upload Photos
                </label>

                <span className={styles.imageCounter}>
                  {images.length}/5
                </span>

              </div>

              <div
                className={styles.dropZone}
                onClick={() =>
                  fileInputRef.current?.click()
                }
                onDragOver={(e) =>
                  e.preventDefault()
                }
                onDrop={(e) => {
                  e.preventDefault();
                  handleImageChange(e);
                }}
              >

                <div className={styles.uploadIconCircle}>

                  <svg
                    width="27"
                    height="27"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#FF6B00"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 16V4" />
                    <polyline points="8 8 12 4 16 8" />
                    <path d="M4 14v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5" />
                  </svg>

                </div>

                <span className={styles.dropText}>
                  Click ya Image Yahan Drag Karein
                </span>

                <span className={styles.dropSubText}>
                  PNG, JPG • Max 5MB per photo
                </span>

              </div>

              <input
                ref={fileInputRef}
                type="file"
                multiple
                accept="image/*"
                onChange={handleImageChange}
                className={styles.hiddenInput}
              />

            </div>

            {/* =================================================
                IMAGE PREVIEWS
            ================================================== */}

            {images.length > 0 && (
              <div className={styles.previewGrid}>

                {images.map((img, index) => (

                  <div
                    key={img.id}
                    className={styles.previewCard}
                  >

                    <img
                      src={img.url}
                      alt={`Work preview ${index + 1}`}
                      className={styles.previewImg}
                    />

                    <div className={styles.imageNumber}>
                      {index + 1}
                    </div>

                    <button
                      type="button"
                      onClick={() =>
                        handleRemoveImage(img.id)
                      }
                      className={styles.removeBtn}
                      aria-label="Remove image"
                    >
                      ×
                    </button>

                  </div>

                ))}

              </div>
            )}

            {/* =================================================
                DESCRIPTION
            ================================================== */}

            <div className={styles.fieldGroup}>

              <label className={styles.label}>
                Work Description
                <span className={styles.optional}>
                  Optional
                </span>
              </label>

              <textarea
                rows="4"
                placeholder="Apne kaam ki details likhein, jaise material konsa use kiya, kitna time laga..."
                value={description}
                onChange={(e) =>
                  setDescription(e.target.value)
                }
                className={styles.textareaInput}
              />

              <div className={styles.characterCount}>
                {description.length} characters
              </div>

            </div>

            {/* =================================================
                SUCCESS MESSAGE
            ================================================== */}

            {successMsg && (
              <div className={styles.successBanner}>

                <div className={styles.successIcon}>
                  ✓
                </div>

                <div>
                  <strong>
                    Upload Successful
                  </strong>

                  <span>
                    {successMsg}
                  </span>
                </div>

              </div>
            )}

            {/* =================================================
                SUBMIT
            ================================================== */}

            <button
              type="submit"
              className={styles.submitBtn}
              disabled={isSubmitting}
            >

              {isSubmitting ? (
                <>
                  <span className={styles.spinner}></span>
                  Uploading...
                </>
              ) : (
                <>
                  Publish Work to Profile

                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 12h14" />
                    <polyline points="13 6 19 12 13 18" />
                  </svg>
                </>
              )}

            </button>

            <div className={styles.bottomNote}>
              <span>✦</span>
              Your work helps customers choose the right
              professional.
            </div>

          </form>

        </div>

      </div>
    </div>
  );
}